import commonUtil from '../../../../../utils/commonUtil';

export const GET_EVENT_DETAILS = 'GET_EVENT_DETAILS';
export const GET_EVENT_DETAILS_SUCCESS = 'GET_EVENT_DETAILS_SUCCESS';
export const GET_EVENT_DETAILS_FAIL = 'GET_EVENT_DETAILS_FAIL';

export const SAVE_OWNER_DETAILS = 'SAVE_OWNER_DETAILS';
export const SAVE_OWNER_DETAILS_SUCCESS = 'SAVE_OWNER_DETAILS_SUCCESS';
export const SAVE_OWNER_DETAILS_FAIL = 'SAVE_OWNER_DETAILS_FAIL';

export const REMOVE_CO_OWNER = 'REMOVE_CO_OWNER';
export const REMOVE_CO_OWNER_SUCCESS = 'REMOVE_CO_OWNER_SUCCESS';
export const REMOVE_CO_OWNER_FAIL = 'REMOVE_CO_OWNER_FAIL';

export const SAVE_EVENT_NAME = 'SAVE_EVENT_NAME';
export const SAVE_EVENT_NAME_SUCCESS = 'SAVE_EVENT_NAME_SUCCESS';
export const SAVE_EVENT_NAME_FAIL = 'SAVE_EVENT_NAME_FAIL';

export const VALIDATE_EVENT_NAME = 'VALIDATE_EVENT_NAME';
export const VALIDATE_EVENT_NAME_SUCCESS = 'VALIDATE_EVENT_NAME_SUCCESS';
export const VALIDATE_EVENT_NAME_FAIL = 'VALIDATE_EVENT_NAME_FAIL';

const GETVALIDATEEVENTNAMEURL = '/api/EventCreation/validateEventName';
const REMOVECOOWNER = '/api/EditEvent/removeCoOwner';
const SAVEEVENTNAME = '/api/EditEvent/saveEventName';

export function getEventDetails(eventId, profileId) {
  const payload = {};
  payload.brand = commonUtil.getBrand().toUpperCase();
  payload.channel = commonUtil.getChannel().toUpperCase();
  payload.eventId = eventId;
  payload.profileId = profileId;
  return {
    types: [GET_EVENT_DETAILS, GET_EVENT_DETAILS_SUCCESS, GET_EVENT_DETAILS_FAIL],
    promise: client => client.post('/api/EditEvent/eventDetails', {
      data: (payload),
    }), // params not used, just shown as demonstration
  };
}

// For Remove Co-owner
export function removeCoOwner(ownerId, eventId) {
  const payload = {};
  payload.brand = commonUtil.getBrand();
  payload.channel = commonUtil.getChannel();
  payload.eventId = eventId;
  payload.ownerId = ownerId;
  return commonUtil.triggerServerRequest({ url: REMOVECOOWNER, method: 'POST', data: payload });
}

// For Save Event Name
export function saveEventName(eventId, newEventName, imageURL) {
  const payload = {};
  payload.brand = commonUtil.getBrand().toUpperCase();
  payload.channel = commonUtil.getChannel().toUpperCase();
  payload.eventId = eventId;
  payload.eventName = newEventName;
  payload.imageURL = imageURL;
  return commonUtil.triggerServerRequest({ url: SAVEEVENTNAME, method: 'POST', data: payload });
}

export function handleSaveEventName(newEventName) {
  return {
    type: SAVE_EVENT_NAME,
    payload: newEventName,
  };
}

// For Validate Event Name
export function handleValidateEventName(eventName, ownerEmail, coOwnerEmail) {
  const payload = {};
  payload.brand = commonUtil.getBrand();
  payload.channel = commonUtil.getChannel();
  payload.eventName = eventName;
  payload.ownerEmail = ownerEmail;
  payload.coOwnerEmail = coOwnerEmail;
  return commonUtil.triggerServerRequest({ url: GETVALIDATEEVENTNAMEURL, method: 'POST', data: payload });
}
